import React, { useState } from 'react';

import Icon from '../../../components/icon/Icon';
import text from '../../../text';
import { useGetPricingCategoriesQuery } from '../../../redux/rtk';
import AddOnPricingModal from './AddOnPricingModal';
import PricingModal from './PricingModal';

// `categoryName` matches backend `Category.name`; `addOn` rows open the
// multiplier modal. Hidden rows have no pricing category yet.
const PRICING_ROWS: {
  icon: string;
  labelKey: string;
  larki?: boolean;
  hidden?: boolean;
  categoryName?: string;
  addOn?: boolean;
}[] = [
  {
    icon: 'interior-point-cloud-enabled',
    labelKey: 'interior3D',
    larki: true,
    categoryName: 'interior',
  },
  {
    icon: 'exterior-point-cloud-enabled',
    labelKey: 'exterior3D',
    larki: true,
    categoryName: 'exterior',
  },
  { icon: 'pedestrian', labelKey: 'pedestrian3D', larki: true, hidden: true },
  {
    icon: 'drone-point-cloud-enabled',
    labelKey: 'drone3D',
    larki: true,
    categoryName: 'drone',
  },
  {
    icon: 'aerial-point-cloud-enabled',
    labelKey: 'aerial3D',
    categoryName: 'aerial',
  },
  {
    icon: 'bim_interior',
    labelKey: 'bim_interior',
    categoryName: 'bim_interior',
    addOn: true,
  },
  {
    icon: 'bim_exterior',
    labelKey: 'bim_exterior',
    categoryName: 'bim_exterior',
    addOn: true,
  },
  {
    icon: 'twod_plan_interior',
    labelKey: 'twod_plan_interior',
    categoryName: 'twod_plan_interior',
    addOn: true,
  },
  {
    icon: 'twod_plan_exterior',
    labelKey: 'twod_plan_exterior',
    categoryName: 'twod_plan_exterior',
    addOn: true,
  },
  { icon: 'site-deployment', labelKey: 'site_deployment_fee', hidden: true },
];

type SelectedProduct = {
  categoryId: number;
  icon: string;
  label: string;
  addOn: boolean;
};

const PricingTab: React.FC = () => {
  const { data: categories } = useGetPricingCategoriesQuery();
  const [selected, setSelected] = useState<SelectedProduct | null>(null);

  const openProduct = (row: (typeof PRICING_ROWS)[number], label: string) => {
    if (!row.categoryName || !categories) return;
    const category = categories.find((c) => c.name === row.categoryName);
    if (!category) return;
    setSelected({
      categoryId: category.id,
      icon: row.icon,
      label,
      addOn: !!row.addOn,
    });
  };

  return (
    <div className='PricingTab'>
      <h3 className='mb-3 green-1'>{text('pricing')}</h3>
      <div className='pricing-list'>
        {PRICING_ROWS.filter((row) => !row.hidden).map((row) => {
          const label = `${row.larki ? 'LARKI ' : ''}${text(row.labelKey)}`;
          return (
            <button
              key={row.icon}
              type='button'
              className='pricing-row'
              onClick={() => openProduct(row, label)}
            >
              <Icon
                icon={row.icon}
                hasIconClass={false}
                className='pricing-row__icon original'
              />
              <span className='pricing-row__label green-1'>{label}</span>
            </button>
          );
        })}
      </div>
      {selected &&
        (selected.addOn ? (
          <AddOnPricingModal
            show
            onHide={() => setSelected(null)}
            categoryId={selected.categoryId}
            icon={selected.icon}
            label={selected.label}
          />
        ) : (
          <PricingModal
            show
            onHide={() => setSelected(null)}
            categoryId={selected.categoryId}
            icon={selected.icon}
            label={selected.label}
          />
        ))}
    </div>
  );
};

export default PricingTab;
